import { createSlice } from "@reduxjs/toolkit";

interface LoaderState {
  pendingRequests: number;
}

const initialState: LoaderState = {
  pendingRequests: 0,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    incrementPending: (state) => {
      state.pendingRequests += 1;
    },
    decrementPending: (state) => {
      state.pendingRequests = Math.max(0, state.pendingRequests - 1);
    },
    resetLoader: (state) => {
      state.pendingRequests = 0;
    },
  },
});

export const { incrementPending, decrementPending, resetLoader } =
  loaderSlice.actions;

// Use a local shape to avoid circular imports (Store/index → routeReducer → loaderSlice → Store/index)
export const selectIsLoading = (state: { loader: LoaderState }) =>
  state.loader.pendingRequests > 0;

export const LoaderReducer = loaderSlice.reducer;
